import WebHotspot from "./WebHotspot";
import NoteHotspot from "./NoteHotspot";
import VideoHotspot from "./VideoHotspot";
import AudioHotspot from "./AudioHotspot";
import LinkHotspot from "./LinkHotspot";
import ElevateDownHotspot from "./ElevateDownHotspot";
import ElevateUpHotspot from "./ElevateUpHotspot";
import FadeHotspot from "./FadeHotspot";
import GalleryHotspot from "./GalleryHotspot";
import PointOfInterestHotspot from "./PointOfInterestHotspot";
import BaseHotspot from "./BaseHotspot";
import MediaHotspot from "./MediaHotspot";
import StickerHotspot from "./StickerHotspot";
import TimelineHotspot from "./TimelineHotspot";

/**
 * Helper class to create hotspots based on a config object
 */
export default class Hotspot {
  /**
   * Returns a hotspot object dependant on the type in the config
   *
   * @param {Player} player
   * @param config - Hotspot configuration
   * @param _hsOptions
   * @return {BaseHotspot} hotspot - A child class of BaseHotspot
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'web',
   *   options: {
   *     url: 'http://google.com'
   *   }
   * }
   */

  static fromConfig(player, config, _hsOptions = null) {
    if (_hsOptions) {
      config = Object.assign({}, config);
      config._options = _hsOptions;
    }

    switch (config.type) {
      case "media":
        return new MediaHotspot(player, config);
      case "sticker":
        return new StickerHotspot(player, config);
      case "link":
        return new LinkHotspot(player, config);
      case "elevate-up":
        return new ElevateUpHotspot(player, config);
      case "elevate-down":
        return new ElevateDownHotspot(player, config);
      case "fade":
        return new FadeHotspot(player, config);
      case "audio":
        return new AudioHotspot(player, config);
      case "gallery":
        return new GalleryHotspot(player, config);
      case "poi":
        return new PointOfInterestHotspot(player, config);
      case "timeline":
        return new TimelineHotspot(player, config);
      case "web":
        return new WebHotspot(player, config);
      case "note": // deprecated
        return new NoteHotspot(player, config);
      case "video": // deprecated
        return new VideoHotspot(player, config);
      default:
        return new BaseHotspot(player, config);
    }
  }
}
